import React from 'react';
import { Box, Heading, Paragraph, Button, Text } from 'components';
import { PortalLink } from 'apps/client/components/PortalLink';
import { formatPrice, formatDate } from 'utils/formatStrings';
import { QuoteCardStyled, CardFooterStyled } from './shipmentQuoteCard.styled';
import { ProductQuoteInfo } from './ProductQuoteInfo';

interface CardProps {
  rfqId: string;
  shipmentQuote: any;
}

export const ShipmentQuoteCard = ({ rfqId, shipmentQuote }: CardProps) => {
  const productQuotes = shipmentQuote.productQuotes.filter(
    (productQuote: any) => productQuote.from.id === rfqId,
  );

  const numOtherPQs = shipmentQuote.productQuotes.length - 1;

  return (
    <QuoteCardStyled>
      <Box
        px={5}
        mb={5}
        sx={{
          justifyContent: 'space-between',
          display: 'flex',
        }}
      >
        <Heading level={2} size='medium'>
          Quote ID:{' '}
          <span style={{ fontWeight: 'normal' }}>
            #{shipmentQuote.decimalId}
          </span>
        </Heading>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <Heading level={2} size='medium' weight='regular'>
            {formatPrice(
              productQuotes[0].finalCost / 100,
              productQuotes[0].currency,
            )}
          </Heading>
          <Text size='xsmall'>
            order to receive by {formatDate(shipmentQuote.deliveryDate)}
          </Text>
        </Box>
      </Box>
      {productQuotes.map((productQuote: any) => {
        return (
          <ProductQuoteInfo
            key={productQuote.id}
            process={productQuote.for.build.process.name}
            material={productQuote.for.build.material.name}
            quantity={productQuote.for.quantity}
            validUntil={productQuote.validUntil}
            supplier={productQuote.supplier?.address?.country}
          />
        );
      })}
      <CardFooterStyled>
        <Paragraph size='small'>
          {numOtherPQs > 0
            ? `This Part was quoted along with ${numOtherPQs} others for a total of `
            : 'This Part was quoted for a total of '}
          <strong>
            {formatPrice(
              shipmentQuote.totalCost / 100,
              productQuotes[0].currency,
            )}
          </strong>
          .
        </Paragraph>
        <PortalLink name='quote' params={{ quoteId: shipmentQuote.decimalId }}>
          <Button
            size='xsmall'
            text='See Quote'
            icon='arrow_right'
            iconPosition='right'
          />
        </PortalLink>
      </CardFooterStyled>
    </QuoteCardStyled>
  );
};
